
import { memo, useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Dumbbell } from "lucide-react";

interface SeriesConfigSectionProps {
  exerciseId: string;
  sets: number;
  onSetsChange: (value: string) => void;
}

export const SeriesConfigSection = memo(function SeriesConfigSection({
  exerciseId,
  sets,
  onSetsChange
}: SeriesConfigSectionProps) {
  // Memoizar opciones de series para evitar re-renders
  const setsOptions = useMemo(() => 
    [1, 2, 3, 4, 5, 6, 7, 8].map((num) => ({
      value: num.toString(),
      label: `${num} ${num === 1 ? 'serie' : 'series'}`
    })), []
  );

  return (
    <div className="bg-gradient-to-r from-[#293233]/10 to-[#253B3D]/10 border border-[#293233]/20 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-4">
        <Dumbbell className="h-5 w-5 text-primary" />
        <h3 className="text-base font-semibold text-primary dark:text-white sunset:text-white forest:text-white ocean:text-white">Numero de Series</h3>

      </div>
      
      <div className="space-y-2">
        <Label htmlFor={`sets-${exerciseId}`} className="text-sm font-medium text-primary dark:text-white ocean:text-black forest:text-white ocean:hover:bg-black sunset:text-white flex items-center gap-2">
          <div className="w-2 h-2 bg-primary rounded-full"></div>
          Series
        </Label>
        <Select value={sets.toString()} onValueChange={onSetsChange}>
          <SelectTrigger 
            id={`sets-${exerciseId}`}
            className="h-11 border-[black]/30  hover:border-[primary]/50 transition-all duration-200 text-primary/90 dark:text-white ocean:text-black forest:text-white ocean:hover:bg-black sunset:text-white bg-white/10"
          >
            <SelectValue placeholder="Seleccionar series" />
          </SelectTrigger>
          <SelectContent className="bg-primary/30 border-primary/30 z-[100] backdrop-blur-md">
            {setsOptions.map((option) => (
              <SelectItem 
                key={option.value} 
                value={option.value}
                className="text-white hover:bg-primary/20 focus:bg-primary/30"
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
});
